import { render } from "./client_admin.html?vue&type=template&id=fabd8da2&external"
import script from "./client_admin.js?vue&type=script&lang=js&external"
export * from "./client_admin.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__